import React from "react";
import Create from "modules/merchantPaymentMethods/components/Create";

const MerchantPaymentMethodsCreatePage = () => {
  return (
    <div>
      <Create />
    </div>
  );
};

export default MerchantPaymentMethodsCreatePage;
